import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Optional,
  Self,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NgControl,
} from '@angular/forms';
import {
  MatFormFieldAppearance,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { UtilsValidators } from '../../validators';
import { ColorPickerModule, ColorPickerService } from 'ngx-color-picker';
import { MatInputModule } from '@angular/material/input';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'sc-color-picker',
  styleUrls: ['./color-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <mat-form-field
      [appearance]="appearance"
      [ngClass]="{
        error:
          (ngControl?.invalid && (ngControl?.dirty || ngControl?.touched)) ||
          forceDisplayError
      }"
    >
      <mat-label
        [class.asterisk]="hasRequiredValidator(ngControl?.control)"
        *ngIf="label"
        >{{ label }}</mat-label
      >
      <input
        #mainInput
        type="text"
        [(colorPicker)]="value"
        [style.background]="value"
        [value]="value"
        cpOutputFormat="hex"
        cpAlphaChannel="disabled"
        (colorPickerSelect)="onInputValueChange($event)"
        (blur)="onTouched()"
        (focusin)="onFocusin()"
        (focusout)="onFocusout()"
        matInput
      />
      <mat-hint *ngIf="!!hint">
        <p>{{ hint }}</p>
      </mat-hint>
    </mat-form-field>
  `,
  imports: [
    MatFormFieldModule,
    NgClass,
    NgIf,
    MatInputModule,
    ColorPickerModule,
  ],
  providers: [ColorPickerService],
})
export class ColorPickerComponent implements ControlValueAccessor {
  @ViewChild('mainInput')
  mainInputElement: ElementRef;

  @Input() appearance: MatFormFieldAppearance = 'fill';
  @Input() value: string;
  @Input() label: string;
  @Input() disabled: boolean;
  @Input() autocomplete = false;
  @Input() forceDisplayError = false;
  @Input() hint: string;
  @Input() clickableIcon = false;

  focus: boolean;

  onChange: any = () => {};
  onTouched: any = () => {};
  onKeyPress: any = () => true;

  constructor(
    @Self()
    @Optional()
    public ngControl: NgControl,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: string): void {
    this.value = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnKeyPress(fn: any): void {
    this.onKeyPress = fn;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputValueChange(value: string) {
    this.value = value;
    this.onChange(value);
  }

  onFocusin() {
    this.focus = true;
  }

  onFocusout() {
    this.focus = false;
  }

  hasRequiredValidator(control: AbstractControl): boolean {
    return UtilsValidators.hasRequiredValidator(control);
  }
}
